
import React from "react";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

interface BlueprintFinalCtaProps {
  isEnrolled: boolean;
  isCourseAvailable: boolean;
  formatReleaseDate: () => string;
  handleWatchIntroClick: () => void;
  onEnrollClick: () => void;
  handleScrollToPricing: () => void;
}

const BlueprintFinalCta: React.FC<BlueprintFinalCtaProps> = ({
  isEnrolled,
  isCourseAvailable,
  formatReleaseDate,
  handleWatchIntroClick,
  handleScrollToPricing
}) => {
  return (
    <div className="bg-gradient-to-br from-techne-purple/10 to-techne-purple/5 rounded-2xl p-10 text-center mt-20">
      <h2 className="text-3xl font-bold mb-4">Ready to Lead AI Governance with Confidence?</h2>
      <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
        Join hundreds of board directors and executives who are using the BoardSight Blueprint to implement effective AI governance.
      </p>
      
      <div className="flex flex-col items-center gap-6">
        {isEnrolled ? (
          <Button 
            size="lg" 
            className="bg-techne-purple hover:bg-techne-deepPurple text-lg px-8"
            onClick={handleWatchIntroClick}
          >
            {isCourseAvailable ? "Access Your Course" : "Watch Preview"}
          </Button>
        ) : (
          <Button 
            size="lg" 
            className="bg-techne-purple hover:bg-techne-deepPurple text-lg px-8"
            onClick={handleScrollToPricing}
          >
            Reserve for December 1, 2025 Cohort
          </Button>
        )}
        
        <a 
          href="https://calendly.com/boardsight/demo" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-techne-purple hover:underline"
        >
          Schedule a team demo <ExternalLink className="h-4 w-4 ml-1" />
        </a>
        
        {!isEnrolled && (
          <div className="text-sm text-muted-foreground mt-2">
            Join our cohort beginning December 1, 2025
          </div>
        )}
      </div>
    </div>
  );
};

export default BlueprintFinalCta;
